// assets/shavi-save-badge.js
document.addEventListener('DOMContentLoaded', function () {
  // Find badge and product JSON
  var badge = document.getElementById('shavi-save-badge');
  if (!badge) return; // nothing to do

  // Find the JSON we rendered for this product (id included in snippet)
  var scriptEl = document.querySelector('script[id^="shavi-product-json-"]');
  if (!scriptEl) return;

  try {
    var product = JSON.parse(scriptEl.textContent);
  } catch (e) {
    return;
  }

  // Helper to update badge
  function updateBadgeForVariant(variant) {
    if (!variant) return;
    var price = variant.price;
    var compare = variant.compare_at_price || 0;
    if (compare && compare > price) {
      var savings = compare - price;
      var percent = Math.round((savings * 100) / compare);
      badge.textContent = 'Save ' + percent + '%';
      badge.setAttribute('data-current-percent', percent);
    } else {
      // No compare price for this variant — hide badge
      badge.style.display = 'none';
    }
  }

  // Initial update - attempt to read currently-selected variant
  // Many themes place a hidden input [name="id"] with selected variant id
  var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], form.product-form [name="id"]');
  if (variantInput) {
    var selectedId = variantInput.value;
    var selectedVariant = product.variants.find(function (v) { return String(v.id) === String(selectedId); });
    if (selectedVariant) {
      updateBadgeForVariant(selectedVariant);
      badge.style.display = ''; // ensure visible if updated
    } else {
      // fallback to product-level default percent (already set by liquid)
      var defaultPercent = badge.getAttribute('data-default-percent');
      if (defaultPercent) {
        badge.textContent = 'Save ' + defaultPercent + '%';
        badge.style.display = '';
      }
    }
  } else {
    // No variant input path found; fallback to default percent
    var defaultPercent = badge.getAttribute('data-default-percent');
    if (defaultPercent) {
      badge.textContent = 'Save ' + defaultPercent + '%';
      badge.style.display = '';
    }
  }

  // Listen for variant changes:
  // 1) If theme triggers a custom DOM event 'variant:change' we can listen
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    updateBadgeForVariant(e.detail.variant);
  });

  // 2) Also watch for change to the variant input/select (fallback)
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.name === 'id') {
      var val = e.target.value;
      var variant = product.variants.find(function (v) { return String(v.id) === String(val); });
      updateBadgeForVariant(variant);
    }
  });
});
